import { CommonModule } from '@angular/common';
import { Component, OnDestroy, Inject } from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageHandlerService } from '@core/services/message-handler/message-handler.service';
import { InputModule } from '@sharedModule/components/input/input.module';
import { ATTRIBUTES_CONSTANT } from '@sharedModule/constants/fields.constant';
import { REGEX_CONSTANT } from '@sharedModule/constants/pattern-regex.constant';
import {
  ConfirmPasswordValidator,
  showValidationMsg,
} from '@sharedModule/utils/form.utils';
import { Subject, takeUntil } from 'rxjs';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'app-change-password-popup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputModule],
  templateUrl: './change-password-popup.component.html',
  styleUrl: './change-password-popup.component.scss',
})
export class ChangePasswordPopupComponent implements OnDestroy {
  public attributeConstant = ATTRIBUTES_CONSTANT;
  changePasswordFrom!: FormGroup;
  isSubmitLoading = false;
  passwordHide = true;
  cPasswordHide = true;
  #destroy$ = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private profileService: ProfileService,
    private messageHandlerService: MessageHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: { userEmail: string },
    public closeDialogRef: MatDialogRef<ChangePasswordPopupComponent>
  ) {
    this.changePasswordFrom = this.fb.group(
      {
        [this.attributeConstant.email.key]: new FormControl(
          this.data.userEmail,
          [Validators.required, Validators.pattern(REGEX_CONSTANT.email)]
        ),
        [this.attributeConstant.new_password.key]: new FormControl('', [
          Validators.required,
        ]),
        [this.attributeConstant.confirm_password.key]: new FormControl('', [
          Validators.required,
        ]),
      },
      {
        validator: ConfirmPasswordValidator(
          this.attributeConstant.new_password.key,
          this.attributeConstant.confirm_password.key
        ),
      }
    );
  }

  onChangePassword(): void {
    showValidationMsg(this.changePasswordFrom);
    if (this.changePasswordFrom.valid) {
      this.profileService
        .changePassword(this.changePasswordFrom.value)
        .pipe(takeUntil(this.#destroy$))
        .subscribe({
          next: x => {
            if (x.success) {
              this.messageHandlerService.show(x.message);
              this.closeDialogRef.close();
            }
          },
          error: error => {
            console.log(error);
            this.closeDialogRef.close();
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }
}
